// src/components/PostForm.js
import React, { useState } from 'react';
import { PostDiscussion } from '../../components/forms/post-discussion';

function PostForm() {
    const tags = ['Examinations', 'Nursing', 'Medical Imaging', 'Physiotherapy', 'Public Health', 'Pharmacy', 'Laboratory Science'];

    const [chosenTags, setChosenTags] = useState([]);

    return (
        <div className='flx-c flx-v  post-form-pg'>
        <PostDiscussion
            tagsData={tags}
            checkTag={(v) => {
                chosenTags.includes(v) ?
                    setChosenTags((t) => t.filter((val) => val !== v)) :
                    setChosenTags((t) => ([...t, v]))
            }}
            checkedData={chosenTags}
        />
        </div>
    );
}

export default PostForm;